import { render, staticRenderFns } from "./MarketPriceValuationTable.vue?vue&type=template&id=2ba949ca&scoped=true&"
import script from "./MarketPriceValuationTable.vue?vue&type=script&lang=ts&"
export * from "./MarketPriceValuationTable.vue?vue&type=script&lang=ts&"
import style0 from "./MarketPriceValuationTable.vue?vue&type=style&index=0&id=2ba949ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba949ca",
  null
  
)

export default component.exports